import React from 'react';
import { Box, Button, Callout, Flex, Icon, Spinner, Text, Tooltip } from 'core/components';

export function TestConnection({
  testConnectionResult,
  isTestingConnection,
  canTestConnection,
  handleTestConnection,
  testConnectionErrors
}) {
  const [showParams, setShowParams] = React.useState(false);

  let resultTitle = 'Connection Successful';

  if (testConnectionResult && !testConnectionResult.connectionSuccessful) {
    resultTitle = 'Request Failed';
  }
  if (testConnectionResult && testConnectionResult.connectionSuccessful && !testConnectionResult.success) {
    resultTitle = 'Connection Failed';
  }

  return (
    <>
      <Flex justifyContent="flex-start" mt={2}>
        <Tooltip
          intent="danger"
          disabled={isTestingConnection || !testConnectionErrors?.length}
          content={
            testConnectionErrors?.length ? (
              <ul style={{ marginBlockStart: 4, marginBlockEnd: 4, paddingInlineStart: 20, maxWidth: 600 }}>
                {testConnectionErrors.map((error) => (
                  <li key={error}>{error}</li>
                ))}
              </ul>
            ) : undefined
          }
        >
          <span>
            <Button
              text={isTestingConnection ? 'Testing...' : 'Test Connection'}
              disabled={!canTestConnection || isTestingConnection}
              icon={isTestingConnection ? <Spinner size={24} /> : undefined}
              onClick={handleTestConnection}
            />
          </span>
        </Tooltip>
      </Flex>

      {testConnectionResult && (
        <Callout border="none" mt={2}>
          <Flex flexDirection="column" gap={2}>
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center" gap={2}>
                <Icon
                  icon={testConnectionResult.success ? 'tick-circle' : 'error'}
                  color={testConnectionResult.success ? 'success' : 'danger'}
                />
                <Text fontWeight="bold" color={testConnectionResult.success ? 'success' : 'danger'}>
                  {resultTitle}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={2}>
                <Text muted fontSize="small">
                  {`Tested at ${new Date(testConnectionResult.timestamp || Date.now()).toLocaleString('en-US', {
                    timeZoneName: 'short',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}`}
                </Text>
                <Button
                  small
                  minimal
                  intent="primary"
                  text={showParams ? 'Hide parameters' : 'View parameters'}
                  onClick={() => setShowParams(!showParams)}
                />
              </Flex>
            </Flex>
            {!testConnectionResult.success && testConnectionResult.error && <Text>{testConnectionResult.error}</Text>}
            {showParams && (
              <Box p={2} bg="white" borderRadius="4px" border="1px solid" borderColor="gray5">
                <Flex flexDirection="column" gap={1}>
                  <Flex>
                    <Text fontSize="small" width="140px">
                      Credentials
                    </Text>
                    <Text fontSize="small" fontFamily="mono">
                      {testConnectionResult.parameters.credentialName}
                    </Text>
                  </Flex>
                  <Flex>
                    <Text fontSize="small" width="140px">
                      Collection Agent
                    </Text>
                    <Text fontSize="small" fontFamily="mono">
                      {testConnectionResult.parameters.agentId}
                    </Text>
                  </Flex>
                  <Flex>
                    <Text fontSize="small" width="140px">
                      Device SNMP IP
                    </Text>
                    <Text fontSize="small" fontFamily="mono">
                      {testConnectionResult.parameters.rangerSnmpIp}
                    </Text>
                  </Flex>
                  <Flex>
                    <Text fontSize="small" width="140px">
                      Port
                    </Text>
                    <Text fontSize="small" fontFamily="mono">
                      {testConnectionResult.parameters.port}
                    </Text>
                  </Flex>
                </Flex>
              </Box>
            )}
          </Flex>
        </Callout>
      )}
    </>
  );
}
